var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_637",
    "data-name": "Group 637",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.857,
    height: 39.294,
    viewBox: "0 0 47.857 39.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_520",
    "data-name": "Rectangle 520",
    width: 47.857,
    height: 39.294,
    fill: "#363636"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M47.63,42.814c-3.332-4.684-6.817-8.966-9.6-13.667-2.643-4.469-.978-10.216,3.145-13.357a10.963,10.963,0,0,1,13.648.4,10.819,10.819,0,0,1,2.4,13.563A46.157,46.157,0,0,1,54.058,34.4c-2.019,2.712-4.1,5.377-6.428,8.418m6.448-18.3a6.336,6.336,0,1,0-12.673,0,6.336,6.336,0,0,0,12.673,0",
    transform: "translate(-23.809 -8.811)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M19.6,4.278,15.8,6.617C13.065,4.231,10.022,3.6,6.861,6.03a6.24,6.24,0,0,0-1.948,6.844C5.8,15.642,8,17.048,11.581,17.253c1.025,2.066,2.038,4.018,2.945,6.018a1.629,1.629,0,0,1-.205,1.355c-1.022,1.429-2.138,2.789-3.317,4.3a13.232,13.232,0,0,1-.956-1.028C7.275,24.184,4.363,20.564,1.786,16.72A10.709,10.709,0,0,1,4.039,2.447a10.893,10.893,0,0,1,14.2.38c.469.428.874.926,1.364,1.451",
    transform: "translate(0 0)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M89.381,29.192c-1.352-1.746-2.521-3.2-3.6-4.709a1.43,1.43,0,0,1-.045-1.207c.9-1.95,1.874-3.866,2.9-5.94,4.007-.383,6.066-1.824,6.84-4.971A6.356,6.356,0,0,0,92.91,5.719c-2.6-1.761-5.14-1.482-8.528.938L80.819,4.45C83.255.1,90.149-1.285,94.943,1.626A10.791,10.791,0,0,1,98.322,16.98c-2.743,4.085-5.805,7.954-8.941,12.211",
    transform: "translate(-52.347 -0.058)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M9.517,71.219,10.79,72.88c-.692.457-1.293.809-1.845,1.225-2.117,1.6-2.133,3.458.062,4.978a13.257,13.257,0,0,0,3.427,1.751,47.291,47.291,0,0,0,29.723-.028,12.884,12.884,0,0,0,3.416-1.773c2.111-1.5,2.1-3.289.067-4.868-.551-.429-1.168-.773-1.951-1.285l1.326-1.669c.67.434,1.279.775,1.828,1.194,3.4,2.592,3.406,5.849-.046,8.4-3.051,2.254-6.639,3.179-10.3,3.79a50.25,50.25,0,0,1-23.488-1.241,19.473,19.473,0,0,1-5.041-2.415c-3.844-2.592-3.777-6.127.023-8.782.429-.3.891-.551,1.525-.938",
    transform: "translate(-3.312 -46.125)",
    fill: "#363636"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.292f407bb4a0c94744f61c2cd223321a.svg";
export { ForwardRef as ReactComponent };